<template>
  <div>
    <v-data-table
      :headers="workItemDataTableHeaders"
      :items="editedEngineerWork.EngineerWorkItems"
      class="elevation-1 my-5 mx-5"
      :search="searchWorkItems"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :item-class="isOutOfWarrantyClass"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('engineer_item_repair_item_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchWorkItems"
            append-icon="mdi-magnify"
            :label="$t('quotation_item_new_install_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="openEditedDialog"
            :disabled="
              isAllTextFieldDisable ||
                !editedEngineerWork.IsAccept ||
                editedEngineerWork.IsDone ||
                editedEngineerWork.IsOutOfTime
            "
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="openEditedNewReturnItemDialog"
            :disabled="
              isAllTextFieldDisable ||
                !editedEngineerWork.IsAccept ||
                editedEngineerWork.IsDone ||
                editedEngineerWork.IsOutOfTime
            "
          >
            裝品項
          </v-btn>
          <v-dialog v-model="isShowNewReturnItemDialog" persistent fullscreen>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <!--維修-裝-->
              <ValidationObserver ref="workItem">
                <v-card flat>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.ReturnItem.IsCustomerDevice"
                            :label="$t('quotation_item_is_customer_device')"
                            required
                            :disabled="editedWorkItem.IsDone"
                            @change="setReturnIsCustomerDevice"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.CustomerDeviceType"
                            :items="computedReturnItemCustomerDeviceTypeList"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('engineer_item_customer_device_type')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-if="editedWorkItem.ReturnItem.IsCustomerDevice"
                            :disabled="editedWorkItem.IsDone"
                            @change="setReturnItemCustomerDeviceType"
                            @keyup.enter="setAcceptanceCustomerDeviceTypeAutocomplete"
                            ref="acceptanceDeviceTypeAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <item-autocomplete-for-eg
                            :fatherEditedItem="editedWorkItem.ReturnItem"
                            :licensePlate="editedEngineerWork.LicensePlate"
                            :editedItemIndex="-1"
                            :itemName="'quotation_item_number'"
                            :customerDeviceType="editedWorkItem.ReturnItem.CustomerDeviceType"
                            @setEditedItem="setEditedReturnItem"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            v-if="editedWorkItemIndex === -1"
                            refName="acceptanceItemAutocomplete"
                            @keyupEnter="focusNextInput"
                          />
                          <ValidationProvider
                            :name="$t('quotation_item_name')"
                            rules="required"
                            v-slot="{ errors }"
                            v-else
                          >
                            <v-text-field
                              v-model="editedWorkItem.ReturnItem.Name"
                              :label="$t('quotation_item_name')"
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_real_quantity')"
                            :rules="{
                              required: true,
                              is: isCheckReturnItemQuantity,
                            }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedWorkItem.ReturnItem.RealQuantity"
                              required
                              clearable
                              :disabled="editedWorkItem.IsDone"
                              :error-messages="errors[0]"
                              @keyup.enter="focusNextInput"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_real_quantity') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          editedWorkItem.ReturnItem.HasSerialNumber &&
                            editedWorkItem.ReturnItem.RealQuantity > 0 &&
                            (!editedWorkItem.ReturnItem.IsCustomerDevice ||
                              (editedWorkItem.ReturnItem.IsCustomerDevice &&
                                editedWorkItem.ReturnItem.CustomerDeviceType === 3))
                        "
                      >
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-combobox
                            v-model="editedWorkItem.ReturnItem.SerialNumber"
                            :label="$t('quotation_item_serialnumber')"
                            v-if="
                              editedWorkItemIndex === -1 ||
                                (!editedWorkItem.IsDone &&
                                  editedWorkItem.ReturnItem &&
                                  editedWorkItem.ReturnItem.Number !== '' &&
                                  editedWorkItem.ReturnItem.HasSerialNumber)
                            "
                            :items="returnItemSerialNumberList"
                            item-text="Number"
                            item-value="Number"
                            required
                            return-object
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            @change="setReturnSerialNumber"
                            @update:search-input="searchInput = $event"
                            @keyup.enter="setAcceptanceSerialNumberAutocomplete"
                            ref="acceptanceSerialNumberAutocomplete"
                          >
                            <template v-slot:append-item>
                              <div v-intersect="isScrollBarBottom" />
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Number }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.ItemName }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-combobox>
                          <v-text-field
                            v-model="editedWorkItem.ReturnItem.SerialNumber.Number"
                            :label="$t('quotation_item_serialnumber')"
                            disabled
                            v-else-if="editedWorkItem.ReturnItem.SerialNumber"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.InstallPosition"
                            :items="allInstallPositionType"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('quotation_item_install_position')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            :disabled="editedWorkItem.IsDone || editedWorkItemIndex !== -1"
                            @keyup.enter="setAcceptanceInstallPositionAutocomplete"
                            @change="setChangeReturnItemInstallPosition"
                            ref="acceptanceInstallPositionAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            name="裝品項歸屬"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              v-model="editedWorkItem.ReturnItem.Custody"
                              :items="allCustodyType"
                              item-text="Name"
                              item-value="Type"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              @keyup.enter="setCustodyAutocomplete"
                              ref="custodyTypeAutocomplete"
                              :error-messages="errors[0]"
                              :disabled="
                                editedWorkItem.IsDone || !editedWorkItem.ReturnItem.IsCustomerDevice
                              "
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                裝品項歸屬
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.ReturnItem.HasAuthorize">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            :items="gmTypeList"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-model="editedWorkItem.ReturnItem.GmServerType"
                            label="GM"
                            :disabled="editedWorkItem.IsDone"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-text-field
                            v-model="editedWorkItem.ReturnItem.AuthorizeItemSerialNumber"
                            label="授權序號"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-select
                            v-model="defaultReturnText"
                            :disabled="isAllTextFieldDisable"
                            :items="defaultTextList"
                            @change="changeReturnDefaultText"
                            label="預設文字"
                            v-if="
                              editedWorkItem.ReturnItem.Quantity * 1 !==
                                editedWorkItem.ReturnItem.RealQuantity * 1
                            "
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_reason')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.ReturnItem.Quantity * 1 !==
                                editedWorkItem.ReturnItem.RealQuantity * 1
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_reason') }}
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                          <ValidationProvider
                            name="換GM Server原因"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.ReturnItem.HasAuthorize &&
                                tempReturnGmServerType !== editedWorkItem.ReturnItem.GmServerType
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                換GM Server原因
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </ValidationObserver>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeEditWorkItem">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="addWorkItem"
                  :disabled="editedWorkItem.IsDone"
                >
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="isShowEditWorkItemDialog" persistent fullscreen>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-spacer></v-spacer>
              </v-card-title>

              <!-- 維修拆 -->

              <v-card flat>
                <v-card-text>
                  <v-container>
                    <ValidationObserver ref="workItem">
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.RemoveItem.IsCustomerDevice"
                            :label="'拆' + $t('quotation_item_is_customer_device')"
                            required
                            :disabled="
                              editedWorkItem.IsDone || editedWorkItem.RemoveItem.IsExistResume
                            "
                            @change="setRemoveIsCustomerDevice"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.RemoveItem.CustomerDeviceType"
                            :items="computedRemoveItemCustomerDeviceTypeList"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('engineer_item_customer_device_type')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-if="editedWorkItem.RemoveItem.IsCustomerDevice"
                            :disabled="
                              editedWorkItem.IsDone || editedWorkItem.RemoveItem.IsExistResume
                            "
                            @change="setRemoveItemCustomerDeviceType"
                            @keyup.enter="setRemoveItemCustomerDeviceTypeAutocomplete"
                            ref="removeItemDeviceTypeAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <item-autocomplete-for-eg
                            :fatherEditedItem="editedWorkItem.RemoveItem"
                            :licensePlate="editedEngineerWork.LicensePlate"
                            :editedItemIndex="editedWorkItemIndex"
                            :itemName="'quotation_item_number'"
                            :customerDeviceType="editedWorkItem.RemoveItem.CustomerDeviceType"
                            @setEditedItem="setEditedRemoveItem"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            v-if="editedWorkItemIndex === -1"
                            refName="removeItemAutocomplete"
                            @keyupEnter="focusNextInput"
                          />
                          <ValidationProvider
                            :name="$t('quotation_item_name')"
                            rules="required"
                            v-slot="{ errors }"
                            v-else
                          >
                            <v-text-field
                              v-model="editedWorkItem.RemoveItem.Name"
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_real_quantity')"
                            :rules="{
                              required: true,
                              is: isCheckRemoveItemQuantity,
                            }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedWorkItem.RemoveItem.RealQuantity"
                              required
                              clearable
                              :disabled="editedWorkItem.IsDone"
                              :error-messages="errors[0]"
                              @change="
                                editedWorkItem.ReturnItem.RealQuantity =
                                  editedWorkItem.RemoveItem.RealQuantity
                              "
                              @keyup.enter="focusNextInput"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_real_quantity') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          xl="4"
                          lg="4"
                          v-if="
                            editedWorkItem.RemoveItem.HasSerialNumber &&
                              editedWorkItem.RemoveItem.IsExistResume &&
                              editedWorkItem.RemoveItem.OriginalSerialNumber
                          "
                        >
                          <v-text-field
                            v-model="editedWorkItem.RemoveItem.OriginalSerialNumber"
                            :label="$t('engineer_item_original_serial_numbers')"
                            disabled
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          editedWorkItem.RemoveItem.HasSerialNumber &&
                            editedWorkItem.RemoveItem.RealQuantity > 0 &&
                            (!editedWorkItem.RemoveItem.IsCustomerDevice ||
                              (editedWorkItem.RemoveItem.IsCustomerDevice &&
                                editedWorkItem.RemoveItem.CustomerDeviceType === 3))
                        "
                      >
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('quotation_item_serialnumber')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              !editedWorkItem.IsDone &&
                                editedWorkItem.RemoveItem.HasSerialNumber &&
                                editedWorkItem.RemoveItem.SerialNumber
                            "
                          >
                            <v-combobox
                              v-model="editedWorkItem.RemoveItem.SerialNumber.Number"
                              :items="removeItemSerialNumberList"
                              item-text="Number"
                              item-value="Number"
                              required
                              return-object
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              @change="setRemoveSerialNumber"
                              @keyup.enter="setRemoveItemSerialNumberAutocomplete"
                              ref="removeItemSerialNumberAutocomplete"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_serialnumber') }}
                              </template>
                            </v-combobox>
                          </ValidationProvider>
                          <v-text-field
                            v-model="editedWorkItem.RemoveItem.SerialNumber.Number"
                            :label="$t('quotation_item_serialnumber')"
                            disabled
                            v-else
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.RemoveItem.InstallPosition"
                            :items="allInstallPositionType"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('quotation_item_install_position')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            :disabled="
                              editedWorkItem.IsDone || editedWorkItem.RemoveItem.IsExistResume
                            "
                            @keyup.enter="setRemoveItemInstallPositionAutocomplete"
                            ref="removeItemInstallPositionAutocomplete"
                            @change="setRealQuantity"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('resume_item_custody')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              v-model="editedWorkItem.RemoveItem.Custody"
                              :items="allCustodyType"
                              item-text="Name"
                              item-value="Type"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              @keyup.enter="setCustodyAutocomplete"
                              ref="custodyTypeAutocomplete"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('resume_item_custody') }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.RemoveItem.IsPersonalFactor"
                            label="人為"
                            :disabled="editedWorkItem.IsDone"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.RemoveItem.HasAuthorize">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            :items="gmTypeList"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-model="editedWorkItem.RemoveItem.GmServerType"
                            label="GM"
                            :disabled="editedWorkItem.IsDone"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-text-field
                            v-model="editedWorkItem.RemoveItem.AuthorizeItemSerialNumber"
                            label="授權序號"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <!-- 維修裝 -->
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.ReturnItem.IsCustomerDevice"
                            :label="'裝' + $t('quotation_item_is_customer_device')"
                            required
                            :disabled="
                              editedWorkItem.IsDone || editedWorkItem.ReturnItem.IsExistResume
                            "
                            @change="setReturnIsCustomerDevice"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.CustomerDeviceType"
                            :items="computedReturnItemCustomerDeviceTypeList"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('engineer_item_customer_device_type')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-if="editedWorkItem.ReturnItem.IsCustomerDevice"
                            :disabled="editedWorkItem.IsDone"
                            @keyup.enter="setReturnItemCustomerDeviceTypeAutocomplete"
                            ref="returnItemDeviceTypeAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          editedWorkItem.RemoveItem.HasSerialNumber &&
                            (!editedWorkItem.ReturnItem.IsCustomerDevice ||
                              (editedWorkItem.ReturnItem.IsCustomerDevice &&
                                editedWorkItem.ReturnItem.CustomerDeviceType === 3))
                        "
                      >
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-combobox
                            v-model="editedWorkItem.ReturnItem.SerialNumber"
                            :label="$t('quotation_item_serialnumber')"
                            v-if="!editedWorkItem.IsDone"
                            :items="returnItemSerialNumberList"
                            item-text="Number"
                            item-value="Number"
                            required
                            return-object
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            @change="setReturnSerialNumber"
                            @update:search-input="searchInput = $event"
                            @keyup.enter="setReturnItemSerialNumberAutocomplete"
                            ref="returnItemSerialNumberAutocomplete"
                          >
                            <template v-slot:append-item>
                              <div v-intersect="isScrollBarBottom" />
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Number }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.ItemName }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-combobox>
                          <v-text-field
                            v-model="editedWorkItem.ReturnItem.SerialNumber.Number"
                            :label="$t('quotation_item_serialnumber')"
                            :disabled="
                              !editedWorkItem.ReturnItem.HasSerialNumber || editedWorkItem.IsDone
                            "
                            v-else-if="editedWorkItem.ReturnItem.SerialNumber"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row
                        v-show="
                          editedWorkItem.ReturnItem.IsCustomerDevice ||
                            (editedWorkItem.RemoveItem.ItemId !== '' &&
                              typeof editedWorkItem.ReturnItem.ItemId !== 'undefined' &&
                              !editedWorkItem.RemoveItem.HasSerialNumber) ||
                            (editedWorkItem.ReturnItem.SerialNumber &&
                              editedWorkItem.ReturnItem.SerialNumber.Number !== '')
                        "
                      >
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <item-autocomplete-group-list-for-eg
                            :fatherEditedItem="editedWorkItem.ReturnItem"
                            :selectItemId="editedWorkItem.RemoveItem.ItemId"
                            :selectItemType="editedWorkItem.RemoveItem.Type"
                            :customerDeviceType="editedWorkItem.ReturnItem.CustomerDeviceType"
                            :itemName="'quotation_item_number'"
                            :editedWorkItemIndex="editedWorkItemIndex"
                            @setEditedItem="setEditedReturnItem"
                            v-show="!editedWorkItem.IsDone"
                            refName="returnItemAutocomplete"
                            @keyupEnter="focusNextInput"
                          />
                          <ValidationProvider
                            :name="$t('quotation_item_name')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="editedWorkItem.IsDone"
                          >
                            <v-text-field
                              v-model="editedWorkItem.ReturnItem.Name"
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.ReturnItem && editedWorkItem.ReturnItem.ItemId">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_real_quantity')"
                            :rules="{
                              required: true,
                              is: isCheckReturnItemQuantity,
                            }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedWorkItem.ReturnItem.RealQuantity"
                              required
                              clearable
                              disabled
                              :error-messages="errors[0]"
                              @keyup.enter="focusNextInput"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_real_quantity') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.ReturnItem && editedWorkItem.ReturnItem.ItemId">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.InstallPosition"
                            :items="allInstallPositionType"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('quotation_item_install_position')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            disabled
                            @keyup.enter="setReturnItemInstallPositionAutocomplete"
                            ref="returnItemInstallPositionAutocomplete"
                            @change="setReturnItemBomName"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            name="裝品項歸屬"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="editedWorkItem.ReturnItem.ItemId"
                          >
                            <v-autocomplete
                              v-model="editedWorkItem.ReturnItem.Custody"
                              :items="allCustodyType"
                              item-text="Name"
                              item-value="Type"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              @keyup.enter="setCustodyAutocomplete"
                              ref="custodyTypeAutocomplete"
                              :error-messages="errors[0]"
                              :disabled="
                                editedWorkItem.IsDone || !editedWorkItem.ReturnItem.IsCustomerDevice
                              "
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                裝品項歸屬
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.ReturnItem.HasAuthorize">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            :items="gmTypeList"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-model="editedWorkItem.ReturnItem.GmServerType"
                            label="GM"
                            :disabled="editedWorkItem.IsDone"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-text-field
                            v-model="editedWorkItem.ReturnItem.AuthorizeItemSerialNumber"
                            label="授權序號"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-select
                            v-model="defaultText"
                            :disabled="isAllTextFieldDisable"
                            :items="defaultTextList"
                            @change="changeDefaultText"
                            label="預設文字"
                            v-if="
                              editedWorkItem.ReturnItem.Quantity * 1 !==
                                editedWorkItem.ReturnItem.RealQuantity * 1 ||
                                editedWorkItem.RemoveItem.Quantity * 1 !==
                                  editedWorkItem.RemoveItem.RealQuantity * 1 ||
                                editedWorkItem.ReturnItem.ItemId === ''
                            "
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_reason')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.ReturnItem.Quantity * 1 !==
                                editedWorkItem.ReturnItem.RealQuantity * 1 ||
                                editedWorkItem.RemoveItem.Quantity * 1 !==
                                  editedWorkItem.RemoveItem.RealQuantity * 1 ||
                                editedWorkItem.ReturnItem.ItemId === ''
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_reason') }}
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                          <ValidationProvider
                            name="換GM Server原因"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              (editedWorkItem.RemoveItem.HasAuthorize &&
                                tempRemoveGmServerType !==
                                  editedWorkItem.RemoveItem.GmServerType) ||
                                (editedWorkItem.ReturnItem.HasAuthorize &&
                                  tempReturnGmServerType !== editedWorkItem.ReturnItem.GmServerType)
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                換GM Server原因
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </ValidationObserver>
                  </v-container>
                </v-card-text>
              </v-card>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeEditWorkItem">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="addWorkItem"
                  :disabled="editedWorkItem.IsDone"
                >
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="false"
            :isLoadingSaveBtn="false"
            :isShowDeleteDialog="isShowDeleteEngineerWorkDialog"
            :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
            @closeDelete="closeDeleteWorkItem"
            @confirmDelete="confirmDeleteWorkItem"
          />
          <v-dialog v-model="isShowSelectSameItemInResume" persistent>
            <v-card>
              <v-card-title class="text-h5">
                請選擇品項
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="selectItemDataTableHeaders"
                  :items="selectFixItemList"
                  class="elevation-1 my-5 mx-5"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_data')"
                  :no-results-text="$t('common_no_results')"
                  :header-props="headerProps"
                  hide-default-footer
                  v-model="selectFixItem"
                  single-select
                  item-key="InstallPosition"
                  show-select
                >
                  <template v-slot:[`item.InstallPosition`]="{ item }">
                    {{ turnData(item.InstallPosition) }}
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeSelectSameItem">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="setSelectSameItem">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="isShowRemindDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="text-h5">
                {{ $t('engineer_remind') }}
              </v-card-title>
              <v-card-text>{{ $t('engineer_remind_message') }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="cancelRemindDialog">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="confirmRemindDialog">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          @click="isShowEditWorkItemDialogBtn(item)"
          :disabled="
            isAllTextFieldDisable ||
              !editedEngineerWork.IsAccept ||
              editedEngineerWork.IsDone ||
              editedEngineerWork.IsOutOfTime
          "
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="isShowDeleteWorkItemDialogBtn(item)"
          :disabled="
            isAllTextFieldDisable ||
              !editedEngineerWork.IsAccept ||
              editedEngineerWork.IsDone ||
              editedEngineerWork.IsOutOfTime
          "
        >
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.RemoveItem.BomName`]="{ item }">
        <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
          {{ item.RemoveItem.BomName }}
        </span>
      </template>
      <template v-slot:[`item.ReturnItem.BomName`]="{ item }">
        <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
          {{ item.ReturnItem.BomName }}
        </span>
      </template>
      <template v-slot:[`item.RemoveItem.BuyOrRentType`]="{ item }">
        <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
          {{ turnBuyOrRentType(item.RemoveItem.BuyOrRentType) }}
        </span>
      </template>
      <template v-slot:[`item.ReturnItem.BuyOrRentType`]="{ item }">
        <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
          {{ turnBuyOrRentType(item.ReturnItem.BuyOrRentType) }}
        </span>
      </template>
      <template v-slot:[`item.RemoveItem.RealQuantity`]="{ item }">
        <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
          {{ item.RemoveItem.RealQuantity }}
        </span>
      </template>
      <template v-slot:[`item.RemoveItem.IsCustomerDevice`]="{ item }">
        <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
          {{ item.RemoveItem.IsCustomerDevice }}
        </span>
      </template>
      <template v-slot:[`item.RemoveItem.WorkType`]="{ item }">
        <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
          {{ turnWorkTypeName(item.RemoveItem.WorkType) }}
        </span>
      </template>
      <template v-slot:[`item.RemoveItem.InstallPosition`]="{ item }">
        <span v-if="item.RemoveItem && item.RemoveItem.ItemId">
          {{ turnData(item.RemoveItem.InstallPosition) }}
        </span>
      </template>
      <template v-slot:[`item.ReturnItem.RealQuantity`]="{ item }">
        <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
          {{ item.ReturnItem.RealQuantity }}
        </span>
      </template>
      <template v-slot:[`item.ReturnItem.IsCustomerDevice`]="{ item }">
        <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
          {{ item.ReturnItem.IsCustomerDevice }}
        </span>
      </template>
      <template v-slot:[`item.ReturnItem.WorkType`]="{ item }">
        <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
          {{ turnWorkTypeName(item.ReturnItem.WorkType) }}
        </span>
      </template>
      <template v-slot:[`item.ReturnItem.InstallPosition`]="{ item }">
        <span v-if="item.ReturnItem && item.ReturnItem.ItemId">
          {{ turnData(item.ReturnItem.InstallPosition) }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>
<style scoped>
.red {
  background-color: red !important;
}
.yellow {
  background-color: yellow !important;
}
</style>
<script>
import { WorkType } from '@/js/WorkType'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import {
  HttpSerialNumber,
  HttpFix,
  HttpAuthorizeMapping,
  HttpInstallPosition
} from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ItemAutocompleteForEg from '@/components/ItemAutocompleteForEg.vue'
import ItemAutocompleteGroupListForEg from '@/components/ItemAutocompleteGroupListForEg.vue'
import { extend } from 'vee-validate'
import { is } from 'vee-validate/dist/rules'
import { CustodyType } from '@/js/CustodyType'
export default {
  components: {
    DeleteDialog,
    ItemAutocompleteForEg,
    ItemAutocompleteGroupListForEg
  },
  name: 'EngineerWorkNotDoneRepair',
  props: {
    headerProps: {
      type: Object
    },
    editedEngineerWork: {
      type: Object
    },
    isAllTextFieldDisable: {
      type: Boolean
    },
    allInstallPositionType: {
      type: Array
    },
    inCarItemList: {
      type: Array
    },
    customerDeviceTypeList: {
      type: Array
    }
  },
  data: () => ({
    gmTypeList: [],
    authorizeMappingReturnObj: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      ItemSerialNumber: '',
      AuthorizeItemSerialNumber: '',
      GmServerType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      DoneTime: 0
    },
    authorizeMappingRemoveObj: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      ItemSerialNumber: '',
      AuthorizeItemSerialNumber: '',
      GmServerType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      DoneTime: 0
    },
    tempReturnGmServerType: 0,
    tempRemoveGmServerType: 0,
    selectFixItem: [],
    searchWorkItems: '',
    isShowDeleteEngineerWorkDialog: false,
    isShowEditWorkItemDialog: false,
    editedWorkItem: {
      RemoveItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        Type: '',
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false
      },
      ReturnItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Type: '',
        Quantity: 0,
        RealQuantity: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2
      },
      Reason: ''
    },
    defaultWorkItem: {
      RemoveItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        Type: '',
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false
      },
      ReturnItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        Type: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2
      },
      Reason: ''
    },
    defaultRemoveItem: {
      BomName: '',
      BuyOrRentType: 0,
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      Type: '',
      OriginalSerialNumber: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPosition: 0,
      HasSerialNumber: false,
      WorkType: 1,
      IsPersonalFactor: false
    },
    defaultReturnItem: {
      BomName: '',
      BuyOrRentType: 0,
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      Type: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPosition: 0,
      HasSerialNumber: false,
      WorkType: 2
    },
    editedWorkItemIndex: -1,
    removeItemSerialNumberList: [],
    returnItemSerialNumberList: [],
    searchInput: null,
    inCarItem: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      Quantity: 0,
      InstallPosition: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      IsOutOfWarranty: false
    },
    tempChangeItem: null,
    tempOriginalItem: null,
    isShowSelectSameItemInResume: false,
    selectFixItemList: [],
    isShowNewReturnItemDialog: false,
    page: 1,
    perPage: 10,
    tempWatchNumber: '',
    searchCount: 0,
    isGetItemFinish: false,
    getIntersectingObj: null,
    isShowRemindDialog: false,
    allCustodyType: [],
    installPositionList: [],
    defaultReturnText: '',
    defaultText: ''
  }),
  async mounted () {
    extend('is', {
      ...is,
      message: () => '只能填寫0、1'
    })
    await this.getAllCustodyType()
    await this.getGmTypeList()
    await this.getAllInstallPositionType()
  },
  computed: {
    defaultTextList () {
      return ['無初始化履歷卡', '初始化履歷卡錯誤']
    },
    computedRemoveItemCustomerDeviceTypeList () {
      let array = []
      if (
        this.editedWorkItem.RemoveItem &&
        this.editedWorkItem.RemoveItem.Number &&
        this.editedWorkItem.RemoveItem.Number.includes('RA400')
      ) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedWorkItem.RemoveItem && this.editedWorkItem.RemoveItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    computedReturnItemCustomerDeviceTypeList () {
      let array = []
      if (
        this.editedWorkItem.ReturnItem &&
        this.editedWorkItem.ReturnItem.Number &&
        this.editedWorkItem.ReturnItem.Number.includes('RA400')
      ) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedWorkItem.ReturnItem && this.editedWorkItem.ReturnItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    workItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'RemoveItem.BomName'
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'RemoveItem.Name'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'RemoveItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'RemoveItem.InstallPosition'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'RemoveItem.WorkType'
        },
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'ReturnItem.BomName'
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'ReturnItem.Name'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'ReturnItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'ReturnItem.InstallPosition'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'ReturnItem.WorkType'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    title () {
      return this.editedWorkItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    isCheckReturnItemQuantity () {
      return (
        (this.editedWorkItem.ReturnItem.HasSerialNumber ||
          (this.editedWorkItem.ReturnItem.InstallPosition !== 0 &&
            this.editedWorkItem.ReturnItem.InstallPosition !== null)) &&
        this.editedWorkItem.ReturnItem.RealQuantity * 1 !== 0 &&
        this.editedWorkItem.ReturnItem.RealQuantity * 1 !== 1
      )
    },
    isCheckRemoveItemQuantity () {
      return (
        (this.editedWorkItem.RemoveItem.HasSerialNumber ||
          (this.editedWorkItem.RemoveItem.InstallPosition !== 0 &&
            this.editedWorkItem.RemoveItem.InstallPosition !== null)) &&
        this.editedWorkItem.RemoveItem.RealQuantity * 1 !== 0 &&
        this.editedWorkItem.RemoveItem.RealQuantity * 1 !== 1
      )
    },
    selectItemDataTableHeaders () {
      return [
        {
          text: this.$t('bom_name'),
          align: 'start',
          value: 'BomName',
          sortable: false
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'ItemNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'ItemName',
          sortable: false
        },
        {
          text: this.$t('bom_item_quantity'),
          align: 'end',
          value: 'Quantity',
          sortable: false
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'end',
          value: 'InstallPosition',
          sortable: false
        }
      ]
    }
  },
  watch: {
    async searchInput (val) {
      this.tempWatchNumber = val
      this.page = 1
      this.returnItemSerialNumberList = []
      this.isGetItemFinish = true
      await this.getTotalCount()
      await this.getReturnItemSerialNumber()
      this.isGetItemFinish = false
    },
    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isGetItemFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getReturnItemSerialNumber()
        }
      }
    }
  },
  methods: {
    changeDefaultText () {
      this.editedWorkItem.Reason = this.defaultText
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
    },
    changeReturnDefaultText () {
      this.editedWorkItem.Reason = this.defaultReturnText
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    async getRemoveAuthorizeMappingByItemIdAndItemSerialNumber () {
      if (this.editedWorkItem.RemoveItem.SerialNumber) {
        let response = await HttpAuthorizeMapping.GetAuthorizeMappingByItemIdAndItemSerialNumber({
          itemId: this.editedWorkItem.RemoveItem.ItemId,
          itemSerialNumber: this.editedWorkItem.RemoveItem.SerialNumber.Number
        })
        this.authorizeMappingRemoveObj =
          response && response.status === 200 ? response.data.Data : {}
      }
    },
    async getReturnAuthorizeMappingByItemIdAndItemSerialNumber () {
      if (this.editedWorkItem.ReturnItem.SerialNumber) {
        let response = await HttpAuthorizeMapping.GetAuthorizeMappingByItemIdAndItemSerialNumber({
          itemId: this.editedWorkItem.ReturnItem.ItemId,
          itemSerialNumber: this.editedWorkItem.ReturnItem.SerialNumber.Number
        })
        this.authorizeMappingReturnObj =
          response && response.status === 200 ? response.data.Data : {}
      }
    },
    setReturnItemCustomerDeviceType () {
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
    },
    setRemoveItemCustomerDeviceType () {
      this.editedWorkItem.RemoveItem = JSON.parse(JSON.stringify(this.editedWorkItem.RemoveItem))
    },
    turnCustodyData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    setCustodyAutocomplete (event) {
      this.$refs.custodyTypeAutocomplete.isMenuActive = false
      this.$refs.custodyTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    async setReturnIsCustomerDevice () {
      if (this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.CustomerDeviceType = 3
      } else {
        this.editedWorkItem.ReturnItem.CustomerDeviceType = 0
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      this.editedWorkItem.ReturnItem.SerialNumber = JSON.parse(
        JSON.stringify(this.defaultWorkItem.ReturnItem.SerialNumber)
      )
    },
    setRemoveIsCustomerDevice () {
      this.editedWorkItem.RemoveItem.CustomerDeviceType = null
      this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(
        JSON.stringify(this.defaultRemoveItem.SerialNumber)
      )
    },
    openEditedNewReturnItemDialog () {
      if (!this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      this.isShowNewReturnItemDialog = true
    },
    setRealQuantity () {
      if (
        this.editedWorkItem.RemoveItem.InstallPosition !== null &&
        this.editedWorkItem.RemoveItem.InstallPosition !== 0
      ) {
        this.editedWorkItem.RemoveItem.RealQuantity = 1
        this.editedWorkItem.ReturnItem.RealQuantity = 1
        this.editedWorkItem.ReturnItem.InstallPosition = this.editedWorkItem.RemoveItem.InstallPosition
      } else if (!this.editedWorkItem.RemoveItem.HasSerialNumber) {
        this.editedWorkItem.RemoveItem.InstallPosition = 0
        this.editedWorkItem.ReturnItem.InstallPosition = 0
      }
    },
    setAcceptanceInstallPositionAutocomplete (event) {
      this.$refs.acceptanceInstallPositionAutocomplete.isMenuActive = false
      this.$refs.acceptanceInstallPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setAcceptanceCustomerDeviceTypeAutocomplete (event) {
      this.$refs.acceptanceDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.acceptanceDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setAcceptanceSerialNumberAutocomplete (event) {
      this.$refs.acceptanceSerialNumberAutocomplete.isMenuActive = false
      this.$refs.acceptanceSerialNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setReturnItemInstallPositionAutocomplete (event) {
      this.$refs.returnItemInstallPositionAutocomplete.isMenuActive = false
      this.$refs.returnItemInstallPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setReturnItemCustomerDeviceTypeAutocomplete (event) {
      this.$refs.returnItemDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.returnItemDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setReturnItemSerialNumberAutocomplete (event) {
      this.$refs.returnItemSerialNumberAutocomplete.isMenuActive = false
      this.$refs.returnItemSerialNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setRemoveItemInstallPositionAutocomplete (event) {
      this.$refs.removeItemInstallPositionAutocomplete.isMenuActive = false
      this.$refs.removeItemInstallPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setRemoveItemCustomerDeviceTypeAutocomplete (event) {
      this.$refs.removeItemDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.removeItemDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setRemoveItemSerialNumberAutocomplete (event) {
      this.$refs.removeItemSerialNumberAutocomplete.isMenuActive = false
      this.$refs.removeItemSerialNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },

    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },

    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.installPositionList
      )
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    isOutOfWarrantyClass (item) {
      if (item.RemoveItem.IsOutOfWarranty && item.RemoveItem.BuyOrRentType === 1) {
        return 'red'
      }
      if (item.RemoveItem.IsPersonalFactor) {
        return 'yellow'
      }
    },
    async getTotalCount () {
      let param
      if (
        this.editedEngineerWork.NumberType === 9 &&
        this.editedEngineerWork.FixType !== 1 &&
        this.editedEngineerWork.FixType !== 2 &&
        this.editedEngineerWork.FixType !== 12 &&
        !this.isShowNewReturnItemDialog
      ) {
        param = {
          returnItemId: this.editedWorkItem.RemoveItem.ItemId,
          number: this.tempWatchNumber,
          groupNumber: this.editedWorkItem.RemoveItem.Type,
          customerDeviceType: this.editedWorkItem.RemoveItem.CustomerDeviceType
            ? this.editedWorkItem.RemoveItem.CustomerDeviceType
            : null,
          customerId: this.editedEngineerWork.CustomerId
        }
      } else {
        param = {
          returnItemId: this.editedWorkItem.ReturnItem.ItemId,
          number: this.tempWatchNumber,
          groupNumber: this.editedWorkItem.ReturnItem.Type,
          customerDeviceType: this.editedWorkItem.ReturnItem.CustomerDeviceType
            ? this.editedWorkItem.ReturnItem.CustomerDeviceType
            : null,
          customerId: this.editedEngineerWork.CustomerId
        }
      }
      let response = await HttpSerialNumber.GetSerialNumberListForEgCount(param)
      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getReturnItemSerialNumber () {
      if (this.searchCount > (this.page - 1) * this.perPage && this.searchCount !== 0) {
        this.isLoadingItem = true
        let param
        if (
          this.editedEngineerWork.NumberType === 9 &&
          this.editedEngineerWork.FixType !== 1 &&
          this.editedEngineerWork.FixType !== 2 &&
          this.editedEngineerWork.FixType !== 12 &&
          !this.isShowNewReturnItemDialog
        ) {
          param = {
            ReturnItemId: this.editedWorkItem.RemoveItem.ItemId,
            GroupNumber: this.editedWorkItem.RemoveItem.Type,
            SearchNumber: this.tempWatchNumber,
            CustomerDeviceType: this.editedWorkItem.RemoveItem.CustomerDeviceType
              ? this.editedWorkItem.RemoveItem.CustomerDeviceType
              : null,
            CustomerId: this.editedEngineerWork.CustomerId,
            Page: this.page,
            PerPage: this.perPage
          }
        } else {
          param = {
            ReturnItemId: this.editedWorkItem.ReturnItem.ItemId,
            GroupNumber: this.editedWorkItem.ReturnItem.Type,
            SearchNumber: this.tempWatchNumber,
            CustomerDeviceType: this.editedWorkItem.ReturnItem.CustomerDeviceType
              ? this.editedWorkItem.ReturnItem.CustomerDeviceType
              : null,
            CustomerId: this.editedEngineerWork.CustomerId,
            Page: this.page,
            PerPage: this.perPage
          }
        }
        let response = await HttpSerialNumber.GetSerialNumberList(param)
        if (response.status === 200) {
          this.returnItemSerialNumberList = [
            ...this.returnItemSerialNumberList,
            ...response.data.Data
          ]
        } else {
          this.returnItemSerialNumberList = []
        }
      }
    },

    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    },
    async setRemoveSerialNumber () {
      if (typeof this.editedWorkItem.RemoveItem.SerialNumber === 'string') {
        let serialNumberObj = this.removeItemSerialNumberList.find(
          (x) => x.Number === this.editedWorkItem.RemoveItem.SerialNumber
        )
        if (serialNumberObj) {
          this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(JSON.stringify(serialNumberObj))
        } else {
          this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(
            JSON.stringify({
              ItemId: this.editedWorkItem.RemoveItem.ItemId,
              Number: this.editedWorkItem.RemoveItem.SerialNumber,
              IsUsed: true,
              AcceptanceNumber: '',
              RepairNumber: ''
            })
          )
        }
      }
      await this.getRemoveAuthorizeMappingByItemIdAndItemSerialNumber()

      if (this.authorizeMappingRemoveObj) {
        this.tempRemoveGmServerType = this.authorizeMappingRemoveObj.GmServerType
        this.editedWorkItem.RemoveItem.GmServerType = this.authorizeMappingRemoveObj.GmServerType
        this.editedWorkItem.RemoveItem.AuthorizeItemSerialNumber = this.authorizeMappingRemoveObj.AuthorizeItemSerialNumber
        this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
      }
    },
    async setReturnSerialNumber () {
      if (typeof this.editedWorkItem.ReturnItem.SerialNumber === 'string') {
        let serialNumberObj = this.returnItemSerialNumberList.find(
          (x) => x.Number === this.editedWorkItem.ReturnItem.SerialNumber
        )
        if (serialNumberObj) {
          this.editedWorkItem.ReturnItem.SerialNumber = JSON.parse(JSON.stringify(serialNumberObj))
        } else {
          this.editedWorkItem.ReturnItem.SerialNumber = JSON.parse(
            JSON.stringify({
              ItemId: this.editedWorkItem.ReturnItem.ItemId,
              ItemNumber: this.editedWorkItem.ReturnItem.Number,
              ItemName: this.editedWorkItem.ReturnItem.Name,
              Number: this.editedWorkItem.ReturnItem.SerialNumber,
              IsUsed: false,
              AcceptanceNumber: '',
              RepairNumber: ''
            })
          )
        }
      }
      if (this.editedWorkItem.ReturnItem.SerialNumber) {
        this.editedWorkItem.ReturnItem.ItemId = this.editedWorkItem.ReturnItem.SerialNumber.ItemId
        this.editedWorkItem.ReturnItem.Number = this.editedWorkItem.ReturnItem.SerialNumber.ItemNumber
        this.editedWorkItem.ReturnItem.Name = this.editedWorkItem.ReturnItem.SerialNumber.ItemName
        this.editedWorkItem.ReturnItem.HasAuthorize = this.editedWorkItem.ReturnItem.SerialNumber.ItemHasAuthorize
        this.editedWorkItem.ReturnItem.HasSerialNumber = true
        this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
      }

      await this.getReturnAuthorizeMappingByItemIdAndItemSerialNumber()

      if (this.authorizeMappingReturnObj) {
        this.tempReturnGmServerType = this.authorizeMappingReturnObj.GmServerType
        this.editedWorkItem.ReturnItem.GmServerType = this.authorizeMappingReturnObj.GmServerType
        this.editedWorkItem.ReturnItem.AuthorizeItemSerialNumber = this.authorizeMappingReturnObj.AuthorizeItemSerialNumber
        this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
      }
    },
    confirmRemindDialog () {
      this.editedWorkItem.ReturnItem.SerialNumber.ItemId = this.tempChangeItem.Id
      this.editedWorkItem.ReturnItem.SerialNumber.ItemNumber = this.tempChangeItem.Number
      this.editedWorkItem.ReturnItem.SerialNumber.ItemName = this.tempChangeItem.Name
      this.editedWorkItem.ReturnItem.ItemId = this.tempChangeItem.Id
      this.editedWorkItem.ReturnItem.Number = this.tempChangeItem.Number
      this.editedWorkItem.ReturnItem.Name = this.tempChangeItem.Name
      this.editedWorkItem.ReturnItem.Unit = this.tempChangeItem.Unit
      this.editedWorkItem.ReturnItem.Price = this.tempChangeItem.Price
      this.editedWorkItem.ReturnItem.IsDelete = this.tempChangeItem.IsDelete
      this.editedWorkItem.ReturnItem.StoreNo = this.tempChangeItem.StoreNo
      this.editedWorkItem.ReturnItem.WarrantyPeriod = this.tempChangeItem.WarrantyPeriod
      this.editedWorkItem.ReturnItem.IsCustomerDevice = this.tempChangeItem.IsCustomerDevice
      this.editedWorkItem.ReturnItem.HasSerialNumber = this.tempChangeItem.HasSerialNumber
      this.editedWorkItem.ReturnItem.IsExistResume = this.tempChangeItem.IsExistResume
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
      this.isShowRemindDialog = false
      this.tempChangeItem = null
      this.tempOriginalItem = null
    },
    cancelRemindDialog () {
      if (this.tempOriginalItem && this.tempOriginalItem.ItemId) {
        this.editedWorkItem.ReturnItem.ItemId = this.tempOriginalItem.ItemId
        this.editedWorkItem.ReturnItem.Number = this.tempOriginalItem.Number
        this.editedWorkItem.ReturnItem.Name = this.tempOriginalItem.Name
        this.editedWorkItem.ReturnItem.Unit = this.tempOriginalItem.Unit
        this.editedWorkItem.ReturnItem.Price = this.tempOriginalItem.Price
        this.editedWorkItem.ReturnItem.StoreNo = this.tempOriginalItem.StoreNo
        this.editedWorkItem.ReturnItem.WarrantyPeriod = this.tempOriginalItem.WarrantyPeriod
        this.editedWorkItem.ReturnItem.IsCustomerDevice = this.tempOriginalItem.IsCustomerDevice
        this.editedWorkItem.ReturnItem.HasSerialNumber = this.tempOriginalItem.HasSerialNumber
        this.editedWorkItem.ReturnItem.IsExistResume = this.tempOriginalItem.IsExistResume
      } else {
        this.editedWorkItem.ReturnItem.ItemId = ''
        this.editedWorkItem.ReturnItem.Number = ''
        this.editedWorkItem.ReturnItem.Name = ''
        this.editedWorkItem.ReturnItem.Unit = ''
        this.editedWorkItem.ReturnItem.Price = 0
        this.editedWorkItem.ReturnItem.StoreNo = ''
        this.editedWorkItem.ReturnItem.WarrantyPeriod = 0
      }
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
      this.isShowRemindDialog = false
      this.tempChangeItem = null
      this.tempOriginalItem = null
    },
    openEditedDialog () {
      if (!this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      this.isShowEditWorkItemDialog = true
    },
    setSelectSameItem () {
      this.editedWorkItem.RemoveItem.InstallPosition = this.selectFixItem[0].InstallPosition
      this.editedWorkItem.ReturnItem.InstallPosition = this.selectFixItem[0].InstallPosition
      this.editedWorkItem.RemoveItem.OriginalSerialNumber = this.selectFixItem[0].SerialNumber
        ? this.selectFixItem[0].SerialNumber.Number
        : ''
      this.editedWorkItem.RemoveItem.IsCustomerDevice = this.selectFixItem[0].IsCustomerDevice
      this.editedWorkItem.RemoveItem.CustomerDeviceType = this.selectFixItem[0].CustomerDeviceType
      this.closeSelectSameItem()
    },
    closeSelectSameItem () {
      this.isShowSelectSameItemInResume = false
      this.selectFixItem = []
      this.selectFixItemList = []
    },
    async setEditedRemoveItem (val) {
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.defaultReturnItem))
      if (!this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      this.selectFixItemList = this.inCarItemList.filter((x) => x.ItemId === val.Id)

      if (this.selectFixItemList !== null && this.selectFixItemList.length > 1) {
        this.editedEngineerWork.EngineerWorkItems.forEach((element) => {
          let index = this.selectFixItemList.findIndex(
            (x) =>
              x.ItemId === element.RemoveItem.ItemId &&
              x.InstallPosition === element.RemoveItem.InstallPosition
          )
          if (index !== -1) {
            this.selectFixItemList.splice(index, 1)
          }
        })
        this.isShowSelectSameItemInResume = true
      }
      this.editedWorkItem.RemoveItem.BomId = val.BomId
      this.editedWorkItem.ReturnItem.BomId = val.BomId
      this.editedWorkItem.RemoveItem.BomName = val.BomName
      this.editedWorkItem.ReturnItem.BomName = val.BomName
      this.editedWorkItem.RemoveItem.BomDescribe = val.BomDescribe
      this.editedWorkItem.ReturnItem.BomDescribe = val.BomDescribe
      this.editedWorkItem.RemoveItem.BuyOrRentType = val.BuyOrRentType
      this.editedWorkItem.ReturnItem.BuyOrRentType = val.BuyOrRentType
      this.editedWorkItem.RemoveItem.ItemId = val.Id
      this.editedWorkItem.RemoveItem.Number = val.Number
      this.editedWorkItem.RemoveItem.Name = val.Name
      this.editedWorkItem.RemoveItem.Unit = val.Unit
      this.editedWorkItem.RemoveItem.Price = val.Price
      this.editedWorkItem.RemoveItem.IsDelete = val.IsDelete
      this.editedWorkItem.RemoveItem.StoreNo = val.StoreNo
      this.editedWorkItem.RemoveItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedWorkItem.RemoveItem.HasSerialNumber = val.HasSerialNumber
      this.editedWorkItem.RemoveItem.HasAuthorize = val.HasAuthorize
      this.editedWorkItem.RemoveItem.IsExistResume = val.IsExistResume
      this.editedWorkItem.RemoveItem.Type = val.Type
      this.editedWorkItem.RemoveItem.IsOutOfWarranty = val.IsOutOfWarranty
      await this.getRemoveItemSerialNumber()

      if (this.editedWorkItem.RemoveItem.IsExistResume) {
        this.inCarItem = this.inCarItemList.find((x) => x.ItemId === val.Id)
        this.editedWorkItem.RemoveItem.Quantity = this.inCarItem.Quantity
        this.editedWorkItem.RemoveItem.RealQuantity = this.inCarItem.Quantity
        this.editedWorkItem.RemoveItem.IsCustomerDevice = this.inCarItem.IsCustomerDevice
        this.editedWorkItem.RemoveItem.CustomerDeviceType = this.inCarItem.CustomerDeviceType
        if (this.editedWorkItem.RemoveItem.HasSerialNumber) {
          this.editedWorkItem.RemoveItem.OriginalSerialNumber = this.inCarItem.SerialNumber.Number
          this.editedWorkItem.RemoveItem.SerialNumber = JSON.parse(
            JSON.stringify(this.inCarItem.SerialNumber)
          )
        }
      } else if (
        !this.editedWorkItem.RemoveItem.IsExistResume &&
        this.editedWorkItem.RemoveItem.HasSerialNumber
      ) {
        this.editedWorkItem.RemoveItem.Quantity = 0
        this.editedWorkItem.RemoveItem.RealQuantity = 1
      } else {
        this.editedWorkItem.RemoveItem.Quantity = 0
        this.editedWorkItem.RemoveItem.RealQuantity = 0
        this.editedWorkItem.RemoveItem.OriginalSerialNumber = ''
        this.editedWorkItem.RemoveItem.InstallPosition = 0
      }
      this.editedWorkItem.RemoveItem = JSON.parse(JSON.stringify(this.editedWorkItem.RemoveItem))
      if (
        this.editedEngineerWork.FixType !== 1 &&
        this.editedEngineerWork.FixType !== 2 &&
        this.editedEngineerWork.FixType !== 12
      ) {
        this.setRepairChangeReturnItemQuantity(val)
        this.page = 1
        this.returnItemSerialNumberList = []
        this.isGetItemFinish = true
        await this.getTotalCount()
        await this.getReturnItemSerialNumber()
        this.isGetItemFinish = false
      }

      await this.getRemoveAuthorizeMappingByItemIdAndItemSerialNumber()

      if (this.authorizeMappingRemoveObj) {
        this.tempRemoveGmServerType = this.authorizeMappingRemoveObj.GmServerType
        this.editedWorkItem.RemoveItem.GmServerType = this.authorizeMappingRemoveObj.GmServerType
        this.editedWorkItem.RemoveItem.AuthorizeItemSerialNumber = this.authorizeMappingRemoveObj.AuthorizeItemSerialNumber
        this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
      }
    },
    setReturnItemBomName () {
      if (this.isShowNewReturnItemDialog) {
        let resumeItem = this.inCarItemList.find(
          (x) => x.ItemId === this.editedWorkItem.ReturnItem.ItemId
        )
        if (resumeItem) {
          this.editedWorkItem.ReturnItem.BomId = resumeItem.BomId
          this.editedWorkItem.ReturnItem.BomName = resumeItem.BomName
          this.editedWorkItem.ReturnItem.BomDescribe = resumeItem.BomDescribe
          this.editedWorkItem.ReturnItem.BuyOrRentType = resumeItem.BuyOrRentType
        }
      }
    },
    async setEditedReturnItem (val) {
      if (
        this.editedEngineerWork.NumberType === 9 &&
        this.editedEngineerWork.FixType !== 1 &&
        this.editedEngineerWork.FixType !== 2 &&
        this.editedEngineerWork.FixType !== 12 &&
        !this.isShowNewReturnItemDialog
      ) {
        this.tempChangeItem = JSON.parse(JSON.stringify(val))
        if (this.editedWorkItem.ReturnItem && this.editedWorkItem.ReturnItem.ItemId !== '') {
          this.tempOriginalItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
        }
        let sn = this.returnItemSerialNumberList.find(
          (x) => x.Number === this.editedWorkItem.ReturnItem.SerialNumber.Number
        )
        if (
          this.editedWorkItem.RemoveItem.HasSerialNumber &&
          !this.editedWorkItem.ReturnItem.IsCustomerDevice &&
          (!sn || val.Id !== sn.ItemId)
        ) {
          this.isShowRemindDialog = true
        } else {
          this.tempChangeItem = null
          this.tempOriginalItem = null
          this.setChangeReturnItem(val)
          this.setRepairChangeReturnItemQuantity(val)
        }
      } else {
        this.setChangeReturnItem(val)
        this.setAcceptanceChangeReturnItemQuantity(val)
        this.page = 1
        this.returnItemSerialNumberList = []
        this.isGetItemFinish = true
        await this.getTotalCount()
        await this.getReturnItemSerialNumber()
        this.isGetItemFinish = false
      }
    },

    setChangeReturnItem (val) {
      this.editedWorkItem.ReturnItem.ItemId = val.Id
      this.editedWorkItem.ReturnItem.Number = val.Number
      this.editedWorkItem.ReturnItem.Name = val.Name
      this.editedWorkItem.ReturnItem.Unit = val.Unit
      this.editedWorkItem.ReturnItem.Price = val.Price
      this.editedWorkItem.ReturnItem.IsDelete = val.IsDelete
      this.editedWorkItem.ReturnItem.StoreNo = val.StoreNo
      this.editedWorkItem.ReturnItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedWorkItem.ReturnItem.HasSerialNumber = val.HasSerialNumber
      this.editedWorkItem.ReturnItem.HasAuthorize = val.HasAuthorize
      this.editedWorkItem.ReturnItem.IsExistResume = val.IsExistResume
      this.setReturnItemBomName()
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
    },
    setChangeReturnItemInstallPosition () {
      if (
        this.editedWorkItem.ReturnItem.InstallPosition !== null &&
        this.editedWorkItem.ReturnItem.InstallPosition !== 0
      ) {
        this.editedWorkItem.ReturnItem.RealQuantity = 1
      }
    },
    setRepairChangeReturnItemQuantity (val) {
      this.inCarItem = this.inCarItemList.find((x) => x.ItemId === val.Id)

      if (this.editedWorkItem.ReturnItem.HasSerialNumber) {
        if (this.inCarItem) {
          this.editedWorkItem.ReturnItem.Quantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.RealQuantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.inCarItem.InstallPosition
        } else {
          this.editedWorkItem.ReturnItem.Quantity = 0
          this.editedWorkItem.ReturnItem.RealQuantity = this.editedWorkItem.RemoveItem.RealQuantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.editedWorkItem.RemoveItem.InstallPosition
        }
      } else {
        if (this.inCarItem) {
          this.editedWorkItem.ReturnItem.Quantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.RealQuantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.inCarItem.InstallPosition
        } else {
          this.editedWorkItem.ReturnItem.Quantity = 0
          this.editedWorkItem.ReturnItem.RealQuantity = this.editedWorkItem.RemoveItem.RealQuantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.editedWorkItem.RemoveItem.InstallPosition
        }
      }
    },
    setAcceptanceChangeReturnItemQuantity (val) {
      this.inCarItem = this.inCarItemList.find((x) => x.ItemId === val.Id)

      if (this.editedWorkItem.ReturnItem.HasSerialNumber) {
        if (this.inCarItem) {
          this.editedWorkItem.ReturnItem.Quantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.RealQuantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.inCarItem.InstallPosition
          this.editedWorkItem.ReturnItem.IsCustomerDevice = this.inCarItem.IsCustomerDevice
          this.editedWorkItem.ReturnItem.CustomerDeviceType = this.inCarItem.CustomerDeviceType
        } else {
          this.editedWorkItem.ReturnItem.Quantity = 0
          this.editedWorkItem.ReturnItem.RealQuantity = 1
        }
      } else {
        if (this.inCarItem) {
          this.editedWorkItem.ReturnItem.Quantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.RealQuantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.inCarItem.InstallPosition
          this.editedWorkItem.ReturnItem.IsCustomerDevice = this.inCarItem.IsCustomerDevice
          this.editedWorkItem.ReturnItem.CustomerDeviceType = this.inCarItem.CustomerDeviceType
        } else {
          this.editedWorkItem.ReturnItem.Quantity = 0
          this.editedWorkItem.ReturnItem.RealQuantity = 0
        }
      }
    },
    async getRemoveItemSerialNumber () {
      let param = {
        itemId: this.editedWorkItem.RemoveItem.ItemId
      }
      let response = await HttpSerialNumber.GetSerialNumberFromItemId(param)
      this.removeItemSerialNumberList = response.status === 200 ? response.data.Data : []
    },

    turnWorkTypeName (val) {
      return WorkType.getFormWorkTypeName(val)
    },

    async isShowEditWorkItemDialogBtn (item) {
      this.editedWorkItemIndex = this.editedEngineerWork.EngineerWorkItems.indexOf(item)
      this.editedWorkItem = JSON.parse(JSON.stringify(item))
      if (!this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      if (this.editedWorkItem.RemoveItem.HasSerialNumber) {
        await this.getRemoveItemSerialNumber()
        await this.getTotalCount()
        await this.getReturnItemSerialNumber()
      }
      if (
        (!this.editedWorkItem.RemoveItem ||
          (this.editedWorkItem.RemoveItem && !this.editedWorkItem.RemoveItem.ItemId)) &&
        this.editedWorkItem.ReturnItem.HasSerialNumber
      ) {
        await this.getTotalCount()
        await this.getReturnItemSerialNumber()
      }
      if (
        (this.editedWorkItem.RemoveItem.HasSerialNumber ||
          this.editedWorkItem.ReturnItem.HasSerialNumber) &&
        (!this.editedWorkItem.ReturnItem.SerialNumber ||
          (this.editedWorkItem.ReturnItem.SerialNumber &&
            !this.editedWorkItem.ReturnItem.SerialNumber.Number))
      ) {
        this.editedWorkItem.ReturnItem.SerialNumber = {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        }
      }

      if (
        this.editedWorkItem.RemoveItem.HasSerialNumber &&
        this.editedWorkItem.RemoveItem.OriginalSerialNumber &&
        !this.editedWorkItem.RemoveItem.SerialNumber
      ) {
        let removeItemSerialNumber = this.removeItemSerialNumberList.find(
          (x) =>
            x.Number === this.editedWorkItem.RemoveItem.OriginalSerialNumber &&
            x.ItemId === this.editedWorkItem.RemoveItem.ItemId
        )
        this.editedWorkItem.RemoveItem.SerialNumber = removeItemSerialNumber || {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        }
      }

      if (this.editedWorkItem.RemoveItem && this.editedWorkItem.RemoveItem.ItemId) {
        this.isShowEditWorkItemDialog = true
      } else {
        this.isShowNewReturnItemDialog = true
      }
      this.editedWorkItem.RemoveItem = JSON.parse(JSON.stringify(this.editedWorkItem.RemoveItem))
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
    },
    async addWorkItem () {
      const isValid = await this.$refs.workItem.validate()
      if (isValid) {
        if (this.editedWorkItemIndex > -1) {
          this.editedEngineerWork.EngineerWorkItems.splice(
            this.editedWorkItemIndex,
            1,
            this.editedWorkItem
          )
        } else {
          this.editedEngineerWork.EngineerWorkItems.push(this.editedWorkItem)
        }
        this.closeEditWorkItem()
      }
    },
    closeEditWorkItem () {
      this.isShowEditWorkItemDialog = false
      this.isShowNewReturnItemDialog = false
      this.$nextTick(() => {
        this.editedWorkItem = JSON.parse(JSON.stringify(this.defaultWorkItem))
        this.editedWorkItemIndex = -1
        this.defaultReturnText = ''
        this.defaultText = ''
      })
    },
    isShowDeleteWorkItemDialogBtn (item) {
      this.editedWorkItemIndex = this.editedEngineerWork.EngineerWorkItems.indexOf(item)
      this.editedWorkItem = JSON.parse(JSON.stringify(item))
      this.isShowDeleteEngineerWorkDialog = true
    },
    async confirmDeleteWorkItem () {
      this.editedEngineerWork.EngineerWorkItems.splice(this.editedWorkItemIndex, 1)
      this.closeDeleteWorkItem()
    },
    closeDeleteWorkItem () {
      this.isShowDeleteEngineerWorkDialog = false
      this.$nextTick(() => {
        this.editedWorkItem = JSON.parse(JSON.stringify(this.defaultWorkItem))
        this.editedWorkItemIndex = -1
      })
    }
  }
}
</script>
